const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/nativeEventsSaga.ts';
import { SagaIterator } from 'redux-saga';
import { put, take } from 'redux-saga/effects';

import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { OPEN_EXTERNAL_BROWSER } from '@cistec/common_web/actions/nativeActions';
import { showUncaughtErrorDialog } from '@cistec/common_web/actions/uiActions';

const Log = Logger('nativeEventsSaga');

/**
 * A list of actions that will be sent to the native wrapper
 */
const nativeActions = [OPEN_EXTERNAL_BROWSER];

/**
 * Saga that listens to actions and posts them to the native wrapper
 */
export function* nativeEventsSaga(): SagaIterator {
    while (true) {
        try {
            const action = yield take(nativeActions);
            (window as any).ReactNativeWebView.postMessage(JSON.stringify(action));
        } catch (e) {
            yield put(showUncaughtErrorDialog('nativeEventsSaga', e));
            Log.error(`Exception! ${e.message}`, e);
        }
    }
}
